import React, {Component} from 'react';
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import {request} from "../../util/APIUtils";
import Table from "../../components/Table/Table";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import {API_BASE_URL} from "../../constants";
import Alert from "react-s-alert";
import LoadingIndicator from "../../common/LoadingIndicator";
import {Button, Dropdown, Menu,} from 'antd';
import Icon from "antd/es/icon";
import { showAxiosError } from '../../util/Helpers';
import SurveyDeleteModal from './SurveyDeleteModal';
import SurveyCreatePage from './SurveyCreatePage';

class NewMySurveys extends Component {

    constructor(props) {
        super(props);

        this.state = {
            surveys: [],
            survey: null,
            error: null,
            manual: false,
            loading: false,
            page: 0,
            currentPage: 1,
            pageSize: 10,
            add: false,
            currentUser:[],
            userId: null,
            selectedSurvey: null,
            selectedItem: null,

            totalIdList: [],
            debtList: [],
            searching: false,
            searchQuery: undefined,
            total: 0,
            size: 10,
            isEditModalOpen: false,
            addNoteModal: false,
            addIncomingModal: false,
            addTransferModal: false,
            addDeleteModal: false,
            mode: this.props.location.mode,
            action: '',
            isLoading: false,
        };
        this.handleSearch = this.handleSearch.bind(this);
        this.addNew = this.addNew.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.fetchSurveys = this.fetchSurveys.bind(this);
        this.handleEdit=this.handleEdit.bind(this);
        this.cancelSurveyCreation = this.cancelSurveyCreation.bind(this);

    }
    componentDidMount() {
        this.fetchSurveys();
    }
    fetchSurveys(page, size, accessor, direction) {
        let sortStr = accessor ? `&sort=${accessor},${direction}` : "&sort=id,asc";
        let searchQuery = this.state.searchQuery ? `&${this.state.searchQuery}` : '';
        let url = `${API_BASE_URL}/anket?page=${page}&size=${size}${sortStr}${searchQuery}`;

        this.setState({
            loading: true,
            manual: this.manual === true ? false : this.manual,
            searching: true
        });
    
        request({ url: url, method: "get" })
            .then(response => {
                let totalChanged = response.data.totalElements !== this.state.total;
                this.setState({
                    page: page,
                    size: size,
                    total: response.data.totalElements,
                    surveys: response.data.content,
                    totalIdList: response.data.content.map(survey => survey.id),
                    loading: false,
                    searching: !totalChanged,
                });
            })
            .catch(error => {
                this.setState({ loading: false, searching: false, error: "Anketler yüklenirken bir sorun oluştu." });
                showAxiosError(error);
            });
    }

    handleLogout() {
        this.props.handleLogout();
    }

    cancelSurveyCreation() {
        this.setState({
            isEditModalOpen: false,
            addDeleteModal: false,
            add:false,
        })
        this.fetchSurveys()
    }

    handleEdit(item) {
        this.setState({
            selectedSurvey: item,
            isEditModalOpen: true,
            add:false
        })
    }

    handleDelete(item) {
        this.setState({
            selectedSurvey: item,
            addDeleteModal: true
        });
    }

    addNew(item) {
        this.setState({
            selectedSurvey: null,
            isEditModalOpen: true,
            add:true
        })
    }
    handleSearch(searchQuery, fromForm) {
        let page = 0;
        if (fromForm) {
            page = this.state.page;
        }
        this.setState({
            searchQuery,
            searching: true,
        }, () => this.fetchSurveys(this.state.accessor, this.state.direction, page, this.state.size))
    }

    handleMenuClick(e) {
        if (e.key === '1') {
            this.handleEdit(this.state.selectedItem);
        } else if (e.key === '2') {
            this.handleDelete(this.state.selectedItem);
        }
    }

    refreshSurveyList() {
        this.fetchSurveys(this.state.page, this.state.size);
    }

    render() {

        const menu = (
            <Menu onClick={this.handleMenuClick}>
                {
                    this.state.selectedItem &&
                    <Menu.Item  key="1">
                        Anket Düzenle
                    </Menu.Item>
                }
                {
                    this.state.selectedItem &&
                    <Menu.Item key="2">
                        Anket Sil
                    </Menu.Item>
                }
            </Menu>
        );
        const columns = [
            {
                Header: "Anket Başlığı",
                accessor: "title",
            },
            {
                Header: "Başlangıç Tarihi",
                accessor: "startDate",
                Cell: (item) => (
                    <label>{new Date(item.startDate).toLocaleDateString("tr")}</label>
                                  ),
            },
            {
                Header: "Bitiş Tarihi",
                accessor: "endDate",
                Cell: (item) => (
                    <label>{new Date(item.endDate).toLocaleDateString("tr")}</label>
                                  ),
            },
         
            {
                Header: "İşlemler",
                accessor: "",
                sortable: false,
                Cell: item => (
                    <div>
                        <Dropdown overlay={menu} trigger='click' onClick={() => this.setState({selectedItem: item})}>
                            <Button style={{
                                background: '#3b6b96',
                                height: '30px',
                                width: '100px',
                                color: 'white',
                                borderRadius: '0.375em',
                                fontSize: "12px",
                            }}>
                                Seçiniz<Icon type="down"/>
                            </Button>
                        </Dropdown>
                    </div>
                )
            }

        ];

        const fields = [
            {
                label: "Anket Başlığı",
                accessor: "title",
                type: "text",
                operator: "=",
            },

        ];

        return (
            <div className="row baseBackground">
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className="col-md-12 satirBasi">
                    <div className="card-header ">
                        <h4 className="card-title">Anket Düzenleme İşlemleri</h4>
                    </div>
                    <div className="card-body mt-1">
                        <div>
                            <div style={{marginTop: '10px', marginBottom: '10px'}}>
                                <DetailedSearch
                                    fields={fields}
                                    loading={this.state.searching}
                                    onSearch={this.handleSearch}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                    <Table
                        loading={this.state.loading}
                        loadingText="Kayıtlar getiriliyor..."
                        content={this.state.surveys}
                        total={this.state.total}
                        page={this.state.page}
                        size={this.state.size}
                        options={["5", "10", "20", "50", "100"]}
                        columns={columns}
                        fetchData={this.fetchSurveys}
                        style={{ width: "100%" }}
                    />
                </div>
                    <div className="new-button-holder">
                        <button type="button" data-toggle="tooltip" data-placement="bottom"
                                title="Yeni Anket Ekle" disabled={this.state.isLoading}
                                style={{
                                    background: 'linear-gradient(#2b93cd, #0a66b7)',
                                    height: '40px',
                                    width: '160px',
                                    float: 'right',
                                    marginRight: '30px',
                                    color: 'white',
                                    borderRadius: '0.375em',
                                }}
                                className="TekBtn add-new-member "
                                rel="tooltip"
                                onClick={() => this.addNew(this.state.selectedItem)}>
                            YENİ ANKET EKLE
                        </button>
                    </div>
                </div>
                <Modal isOpen={this.state.isEditModalOpen} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelSurveyCreation}>
                        {this.state.add
                            ?
                            'Yeni Anket Ekleme'
                            :
                            'Anket Düzenleme'
                        }
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <SurveyCreatePage
                            cancelProcess={this.cancelSurveyCreation}
                            survey={this.state.selectedSurvey}
                            currentUser={this.props.currentUser}
                            mode={this.state.mode}
                            module={this.props.title}
                            handleSearch={this.handleSearch}
                            searchQuery={this.state.searchQuery}
                            handleLogout={this.handleLogout}
                            refreshSurveyList={this.refreshSurveyList} 

                            onClose={() => this.setState({ isEditModalOpen: false, survey: null })}
                            add={this.state.add}
                        />
                    </ModalBody>
                </Modal>
                <Modal isOpen={this.state.addDeleteModal} size="lg" className="ust">
                    <ModalHeader toggle={this.cancelSurveyCreation}>
                        Anket Silme
                    </ModalHeader>
                    <ModalBody style={{'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto'}}>
                        <SurveyDeleteModal
                            cancelProcess={this.cancelSurveyCreation}
                            survey={this.state.selectedSurvey}
                            handleLogout={this.handleLogout}
                            refreshSurveyList={this.refreshSurveyList} 

                        />
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}






export default NewMySurveys;


// WEBPACK FOOTER //
// ./src/page/surveypage/NewMySurveys.js